import T from 'i18n-react';

import { ArrowDownIcon, ArrowUpIcon } from '@motorway/mw-highway-code';
import { Chip } from '@motorway/mw-highway-code/pre-alpha';

import cypressIds from 'Components/cypress_ids.json';
import texts from 'Components/texts.json';
import { useSetIsHoveringSavedSearchesChip } from 'Stores/SavedFiltersActionsStore/SavedFiltersActionsStore';
import {
	useIsSavedSearchPillOpen,
	useSetIsClickedOutsidePillButton,
	useSetIsSavedSearchPillOpen,
} from 'Stores/SavedFiltersStore/SavedFiltersStore';
import { applyCypressData } from 'Utilities/helpers';

T.setTexts(texts);

interface SavedSearchOptionsToggleProps {
	onClick?: () => void;
	onMouseEnter?: () => void;
}

export const SavedSearchOptionsToggle: React.FC<SavedSearchOptionsToggleProps> = ({ onClick, onMouseEnter }) => {
	const setIsClickedOutsidePillButton = useSetIsClickedOutsidePillButton();
	const setIsSavedSearchPillOpen = useSetIsSavedSearchPillOpen();
	const isSavedSearchPillOpen = useIsSavedSearchPillOpen();
	const setIsHoveringSavedSearchesChip = useSetIsHoveringSavedSearchesChip();
	const onMouseEnterHandler = () => setIsHoveringSavedSearchesChip(true);
	const onMouseLeaveHandler = () => setIsHoveringSavedSearchesChip(false);

	const onChipClick = () => {
		setIsClickedOutsidePillButton(false);
		setIsSavedSearchPillOpen(!isSavedSearchPillOpen);
		onClick?.();
	};

	const icon = isSavedSearchPillOpen ? (
		<ArrowUpIcon data-icon="chevronUp" />
	) : (
		<ArrowDownIcon data-icon="chevronDown" />
	);

	return (
		<div onMouseEnter={onMouseEnterHandler} onMouseLeave={onMouseLeaveHandler}>
			<Chip
				{...{ onMouseEnter, ...applyCypressData(cypressIds.inputs.toggleShowSavedFilters) }}
				filled
				aria-label={`${T.translate(`savedSearch.savedSearchPill.${isSavedSearchPillOpen ? 'ariaClose' : 'ariaOpen'}`)}`}
				icon={() => icon}
				label={T.translate('savedSearch.savedSearchPill.buttonText')}
				onClick={onChipClick}
			/>
		</div>
	);
};
